/**
 * Файл генерируется автоматически командой `npm run generate:advanced-filter`.
 * Не стоит его изменять руками, если вы не уверены в том, что делаете :)
 */
import { IFilter, TFilter } from '../../types/advancedFilters';
import { apartments } from './apartments';
import { balcony } from './balcony';
import { bathType } from './bathType';
import { ceilingHeight } from './ceilingHeight';
import { completionYear } from './completionYear';
import { constructionType } from './constructionType';
import { constructionYear } from './constructionYear';
import { contact } from './contact';
import { containWords } from './containWords';
import { dealType } from './dealType';
import { demolition } from './demolition';
import { elevators } from './elevators';
import { excludeWords } from './excludeWords';
import { facilities } from './facilities';
import { finishing } from './finishing';
import { flatRooms } from './flatRooms';
import { floor } from './floor';
import { floors } from './floors';
import { fromMKAD } from './fromMKAD';
import { heatingType } from './heatingType';
import { landStatus } from './landStatus';
import { layout } from './layout';
import { livingConditions } from './livingConditions';
import { offerId } from './offerId';
import { offerType } from './offerType';
import { parking } from './parking';
import { publicationDate } from './publicationDate';
import { rentTerms } from './rentTerms';
import { rentalPeriod } from './rentalPeriod';
import { repair } from './repair';
import { roomsInDeal } from './roomsInDeal';
import { saleType } from './saleType';
import { squareMeterArea } from './squareMeterArea';
import { suburbanArea } from './suburbanArea';
import { suburbanBathroom } from './suburbanBathroom';
import { suburbanFacilities } from './suburbanFacilities';
import { suburbanUtilities } from './suburbanUtilities';
import { undergroundTime } from './undergroundTime';
import { urbanBathroom } from './urbanBathroom';
import { windows } from './windows';
import { withNeighbors } from './withNeighbors';
/* marker: prepend import */

export const ADVANCED_FILTERS: { [key in TFilter]: IFilter } = {
  withNeighbors,
  apartments,
  urbanBathroom,
  suburbanBathroom,
  ceilingHeight,
  constructionType,
  constructionYear,
  containWords,
  elevators,
  excludeWords,
  flatRooms,
  floor,
  floors,
  layout,
  parking,
  publicationDate,
  repair,
  saleType,
  squareMeterArea,
  windows,
  heatingType,
  undergroundTime,
  demolition,
  finishing,
  completionYear,
  balcony,
  dealType,
  roomsInDeal,
  suburbanUtilities,
  fromMKAD,
  offerType,
  suburbanArea,
  rentTerms,
  facilities,
  bathType,
  livingConditions,
  rentalPeriod,
  suburbanFacilities,
  landStatus,
  contact,
  offerId,
  /* marker: prepend key */
};
